import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Alert, Box, Button, CircularProgress, Stack, Typography } from '@mui/material';
import TopAppBar from '../layout/TopAppBar';
import { PageContainer } from '../ui/ConvivialComponents';
import TableListCard from '../ui/TableListCard';
import { getRestaurant, getRestaurantGroups } from '../../services/firebaseData';

export default function RestaurantPage() {
    const { restaurant_id } = useParams();
    const navigate = useNavigate();
    const [restaurant, setRestaurant] = useState(null);
    const [groups, setGroups] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        let active = true;
        setLoading(true);
        setError('');
        Promise.all([getRestaurant(restaurant_id), getRestaurantGroups(restaurant_id)])
            .then(([place, tables]) => {
                if (active) { setRestaurant(place); setGroups(tables); }
            })
            .catch(() => { if (active) setError('Impossibile caricare il ristorante. Riprova.'); })
            .finally(() => { if (active) setLoading(false); });
        return () => { active = false; };
    }, [restaurant_id]);

    function createTable() {
        // Reuse the existing creation form and its login flow.
        localStorage.setItem('searchedPlace', JSON.stringify({ ...restaurant.location,
            place: restaurant.name, directions: restaurant.address,
            placeId: restaurant.id, restaurantId: restaurant.id }));
        localStorage.setItem('lastQueryPlace', restaurant.name);
        localStorage.setItem('tableVenue', restaurant.id);
        navigate('/table');
    }

    return <>
        <TopAppBar title="Ristorante Convivial" variant="back" />
        <PageContainer sx={{ pt: 'calc(var(--cv-top-bar-height) + 32px)' }}>
            {loading ? <CircularProgress /> : error ? <Alert severity="error">{error}</Alert> : !restaurant ?
                <Alert severity="info">Ristorante non disponibile.</Alert> :
                <Stack spacing={2.5}>
                    <Box>
                        <Typography variant="h1" sx={{ color: 'primary.main', fontSize: { xs: 28, sm: 34 } }}>
                            {restaurant.name}
                        </Typography>
                        <Typography variant="body1" sx={{ color: 'text.secondary' }}>{restaurant.address}</Typography>
                        <Typography variant="body1" sx={{ mt: 2, whiteSpace: 'pre-wrap' }}>
                            {restaurant.promotion || 'Un ristorante aderente, pronto ad accogliere i tavoli Convivial.'}
                        </Typography>
                    </Box>
                    <Box>
                        <Typography variant="h2" sx={{ color: 'primary.main' }}>Tavoli aperti</Typography>
                        <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                            Scegli un tavolo già aperto per mangiare in compagnia.
                        </Typography>
                    </Box>
                    {groups.length === 0 && <Typography color="text.secondary">Nessun tavolo aperto: organizza il primo!</Typography>}
                    {groups.map((group) => <TableListCard key={group.id} table={group} />)}
                    <Button variant="outlined" onClick={createTable}>Organizza un nuovo tavolo qui</Button>
                </Stack>}
        </PageContainer>
    </>;
}
